import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";


@Component({
    selector: 'main-pg',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="main-pg">
            <ng-content select="[header]"></ng-content>
            <div [class]="pgContainerClass">  
                @if(__side){
                    <ng-content select="[side]"></ng-content>
                } 
                <ng-content select="[contest]"></ng-content>  
            </div>
            <!---->
        </div> 
        <div class="main-pg-contents-footer">
            <ng-content select="[footer]"></ng-content>
        </div>
    `,
})
export class MainPageGrid {

    @Input() sideOnTop = false;

    __side = false;

    public closeSide() {
        this.__side = false;
    }

    public openSide() {
        this.__side = true;
    }

    public switchSide() {
        this.__side = !this.__side;
    }

    public get pgContainerClass() {
        if (!this.__side) {
            return "main-pg-container-no-side";
        } else if (this.sideOnTop) {
            return "main-pg-container-overlay";
        }
        return "main-pg-container";
    }

}